import React from "react";
// import prodimg from "../../../assets/images/pro-img1.png";
import { Loader, ProductImage } from "../../../reauseble";
import { Link } from "react-router-dom";
import smokeimg from "../../../assets/images/regulations.png";
import { FaStar } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import colors from "../../../assets/colors";
import { useNavigate } from "react-router-dom/dist";

const { colorPrimary,colorSecondary } = colors;

const styles = {
	card: {
		// borderColor: colorSecondary,
		// padding: "1em",
		// textAlign:"center",
		// width: '25rem',
		// margin:"1.5%",
		// borderRadius:"20px"
	},
	// btn: {
	// 	backgroundColor: colorPrimary,
	// 	borderRadius: "30px"
	// }
}

const Sec2 = ({ loading }) => {
const navigate = useNavigate(); 
	const data = [
		{
			title: "Regulations",
			img: smokeimg
		},
		{
			title: "Guide",
			img: smokeimg

		},
		{
			title: "Circulars",
			img: smokeimg

		}

	]

	const handleBtnClick = (data) => {
		// console.log(data)
		navigate(`/Library/Legal&RegulatoryInformation/${data.title}`, {
			state: {
				...data,
			},
		});
	}

	return (
		<>

			<section className='sec sec2'>

				<div className='container'>
					<div className="flex_btw">
					<h1 className="bold">Legal & Regulatory Information
					</h1>
					<button onClick={()=>navigate('/Library/Legal&RegulatoryInformation')} className="rounded_btn">View More</button>
					</div>

					<div>

						{data.map((e) => {
							return <>
								<Card className="legalnRegcards">
									<img variant="top" src={e.img} />
									{/* <Card.Img className="card_img"  variant="top" src={smokeimg2} /> */}
								<h4>{e.title}</h4>
								<Button className="card_btn" onClick={() => handleBtnClick(e)} variant="primary">Read More</Button>
									
								</Card>


							</>
						})}
						{/* {!loading && data
									? data.map((val) => {
										const image = val.attachment.filter(
											(att) => att.type == 0
										);
										return (
											<>
												<li key={val.id}>
													<Link to={`/singleproduct/${val.id}`}>
														<img
															src={
																val.featured_image
																	? `http://upload.pegasusdeliveryllc.com/v1/fetch/file/${val.featured_image}`
																	: ProductImage
															}
															className='prod_img'
															alt='featured image'
														/>
													</Link>
													<h3 className='prod_title'>{val.name}</h3>
													<span className='prod_price'>
														{val?.sale_price > 0 ? (
															<span
																className='regular_price'
																style={{
																	textDecoration: "line-through",
																}}>
																<span className='curreny'>$ </span>
																{val.price}
															</span>
														) : (
															<span
																className='discount_price'
																style={{ textDecoratione: "line-through" }}>
																<span className='curreny'>$ </span>
																{val.price}
															</span>
														)}

														{val?.sale_price > 0 && (
															<span
																className='discount_price'
																style={{ marginLeft: "10px" }}>
																<span className='curreny'>$</span>
																{val?.sale_price}
															</span>
														)}
													</span>
													<h3
														style={{
															color: "white",
															fontSize: "14px",
															margin: "10px 0px",
														}}>
														<span>
															{val?.avg_rating ? val.avg_rating : "0"}
														</span>

														<FaStar
															style={{
																paddingTop: "4px",
																marginLeft: "1px",
															}}
															size='16'
															color='yellow'
														/>
													</h3>
												</li>
											</>
										);
									})
									: null} */}
						{/* <Loader loading={loading} /> */}
					</div>

				</div>
			</section>
		</>
	);
};

export default Sec2;
